import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import HomePage from "./pages/HomePage";
import EventsPage from "./pages/EventsPage";
import DentalLab from "./pages/DentalLab";
import SharePage from "./pages/SharePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AnalyzePage from "./pages/AnalyzePage";
import MIS from "./pages/MIS";
import PostDetail from "./pages/PostDetail";
import BuyCreditsPage from "./pages/BuyCreditsPage";
import ProfilePage from "./pages/ProfilePage";
import SocialPage from "./pages/SocialPage";
import SocialBrandDetailPage from "./pages/SocialBrandDetailPage";
import RenewSubscriptionPage from "./pages/RenewSubscriptionPage";

// ✅ DÜZELTİLDİ: import isimleri Route ile aynı
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

// ✅ Route koruma bileşeni
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-sidebar",
      collapsed ? "collapsed" : "expanded"
    );
  }, [collapsed]);

  return (
    <>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div className="app-shell">
        <Routes>
          {/* ✅ Herkesin görebileceği sayfalar */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          {/* ✅ Reset link genelde /reset-password/:uid/:token gelir */}
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
          <Route path="/renew-subscription" element={<RenewSubscriptionPage />} />

          {/* ✅ Giriş zorunlu sayfalar */}
          <Route
            path="/social"
            element={
              <ProtectedRoute>
                <SocialPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/social/:brandSlug"
            element={
              <ProtectedRoute>
                <SocialBrandDetailPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/news"
            element={
              <ProtectedRoute>
                <SharePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <EventsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/lab"
            element={
              <ProtectedRoute>
                <DentalLab />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analyze"
            element={
              <ProtectedRoute>
                <AnalyzePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sosyal/mis"
            element={
              <ProtectedRoute>
                <MIS />
              </ProtectedRoute>
            }
          />

          <Route
            path="/guncel/:id"
            element={
              <ProtectedRoute>
                <PostDetail />
              </ProtectedRoute>
            }
          />

          <Route
            path="/buy-credits"
            element={
              <ProtectedRoute>
                <BuyCreditsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </>
  );
}
